import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { usePatient } from "../../context/PatientContext";
import { useAuth } from "../../context/AuthProvider";

const AddNewCase = () => {
  const { verifyTokenAndRedirect } = useAuth();
  const { patientId, caseId } = useParams();
  const { patientData, setPatientData, setSelectedVisit } = usePatient();
  const navigate = useNavigate();

  useEffect(() => {
    verifyTokenAndRedirect();
  }, []);

  useEffect(() => {
    const createAndRedirect = async () => {
      try {
        // Simulate visit ID creation
        const newVisitId = 1;

        setSelectedVisit(newVisitId);

        // Mark intent in context
        const updatedPatientData = { ...patientData, ACTION_STATUS: "ADD_NEW_CASE" };
        setPatientData(updatedPatientData);

        // Navigate to the edit form of the new visit
        navigate(`/visits/${patientId}/${caseId}/${newVisitId}`);
      } catch (error) {
        console.error("Error creating new case:", error);
      }
    };

    createAndRedirect();
  }, [patientId, caseId, patientData, setSelectedVisit, setPatientData, navigate]);

  return <div>Creating a new case and redirecting...</div>;
};

export default AddNewCase;
